module.exports = __webpack_public_path__ + "static/media/sm.758d5f5b.svg";